import { ReactNode } from "react";
import mixin from "../utils/helperFunction";

interface FallBackUserDivProps {
    initials?: string;
    children?: ReactNode
    rounded?: boolean;
    size?: "lg" | "sm" | "mini" | 'base' | "xl"| "md";
}

export default function FallBackUserDiv({
    initials,
    rounded,
    children,
    size = "sm",
}:FallBackUserDivProps) {

  const computedSize = () => {
    switch (size) {
      case "xl":
        return "h-32 w-32";
      case "lg":
        return "h-24 w-24";
      case "md":
        return "h-14 w-14";
      case 'base':
        return "h-10 w-10";
      case "mini":
        return "h-6 w-6";
      default:
        return "h-8 w-8";
    }
  }

  return (
    <div className="relative">
      <div
        className={` ${mixin.setRandomColorArray(initials)} ${computedSize()} ${rounded ? ' rounded-full ' : ' rounded-md ' }  flex items-center justify-center text-sm font-medium text-white transition-transform transform hover:z-10`}
      >
        {initials || 'TV'}
      </div>
      {(children) && <div className="absolute -bottom-2 -right-2">
        {children}
      </div>}
    </div>
  );
}
